import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark2Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCheckmark2Small"><Path fillRule="evenodd" clipRule="evenodd" d="M18.3079 7.67302L9.93671 17.3539L5.68933 13.056L6.75625 12.0016L9.86324 15.1456L17.1732 6.69189L18.3079 7.67302Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark2Small;
